import React from 'react';
import { PropTypes } from 'prop-types';
import { useSelector } from 'react-redux';

const EvidentiaryDocs = ({ input, className, showCollectableSupportingDocs, collectableSupportingDocs }) => {
  const documentTypes = useSelector(state => state.auth.settings.supportingDocTypes);
  const supportingDocs = documentTypes.map(obj => ({ ...obj }));
  if (showCollectableSupportingDocs && collectableSupportingDocs) {
    collectableSupportingDocs.forEach((doc) => {
      if (!supportingDocs.some(item => item.key === doc.key)) {
        supportingDocs.push({
          key: doc.key,
          value: doc.value
        });
      }
    });
    supportingDocs.sort((a, b) => a.key.localeCompare(b.key));
  }

  return (
    <div>
      <select value={ input.value } className={ className } onChange={ (e) => { input.onChange(e, e.target.value); } } aria-label="Supporting Document Type">
        <option value="" disabled>Choose a document type</option>
        {showCollectableSupportingDocs && supportingDocs.map(item => <option key={ item.key } value={ item.key }>{ item.value }</option>) }
        {!showCollectableSupportingDocs && documentTypes.map(item => <option key={ item.key } value={ item.key }>{item.value}</option>)}
      </select>
    </div>
  );
};

EvidentiaryDocs.propTypes = {
  input: PropTypes.shape({
    onChange: PropTypes.func.isRequired,
    value: PropTypes.string.isRequired,
  }).isRequired,
  className: PropTypes.string,
  showCollectableSupportingDocs: PropTypes.bool,
  collectableSupportingDocs: PropTypes.arrayOf(PropTypes.shape())
};

EvidentiaryDocs.defaultProps = {
  className: '',
  showCollectableSupportingDocs: false,
  collectableSupportingDocs: null
};

export default EvidentiaryDocs;
